var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelectionList01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16.021px",
    height: "15.954px",
    viewBox: "78.925 160.814 16.021 15.954",
    enableBackground: "new 78.925 160.814 16.021 15.954",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M86.039,163.467v1.023h8.907v-1.023H86.039z M90.987,168.583h-4.948v1.023h4.948V168.583z M86.039,174.722 h6.928v-1.023h-6.928V174.722z M81.155,164.392l-1.529-1.582l-0.7,0.723l2.229,2.307l4.161-4.302l-0.699-0.724L81.155,164.392z  M80.1,171.652h3.959v-4.092H80.1V171.652z M81.089,168.583h1.979v2.046h-1.979V168.583z M80.1,176.768h3.959v-4.093H80.1V176.768 z M81.089,173.699h1.979v2.046h-1.979V173.699z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectionList01);
export default __webpack_public_path__ + "static/media/icon_selection_list-01.209b868fb9b53e74b04082e7a7fef6c0.svg";
export { ForwardRef as ReactComponent };